import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { ChatTypes } from '@sda/enums';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ChatOptions, MessagesState } from '@sda/interfaces/reducer/messages.reducer';
import type { Message } from '@sda/interfaces/message';
import type { FetchDataType } from '@sda/sdk/interfaces';

// LISTENERS

export const startAddMessage = createAction<{ message: string, pinned: boolean }>(`${Reducers.MESSAGES}/startAddMessage`);
export const startAttachFile = createAction<string>(`${Reducers.MESSAGES}/startAttachFile`);
export const startSetReadReceipt = createAction<string>(`${Reducers.MESSAGES}/startSetReadReceipt`);
export const startPinMessage = createAction<{ messageId: string, pinned: boolean }>(`${Reducers.MESSAGES}/startPinMessage`);
export const startDeleteMessage = createAction<{ messageId: string, block: boolean }>(`${Reducers.MESSAGES}/startDeletedMessage`);

/**
 * data fetching
 */
export const startRefetchMessages = createAction(`${Reducers.MESSAGES}/startRefetchMessages`);
export const startFetchChatMessages = createAction(`${Reducers.MESSAGES}/startFetchChatMessages`);
export const unsubscribeMessages = createAction(`${Reducers.MESSAGES}/unsubscribeMessages`);
export const startFetchMessageAuthor = createAction<string>(`${Reducers.MESSAGES}/startFetchMessageAuthor`);

export const messagesPerPage = 20;

const initialChatOptions = {
  acceptingNew: true,
  allowAttachments: false,
  allowReadReceipts: false,
  allowTypingStates: false,
  allowPinnedMessages: false,
  chatEnabled: null,
  chatId: null,
  chatLocked: null,
  chatType: ChatTypes.THREAD_CHAT,
  profileLinks: false,
};

export const messageAdapter = createEntityAdapter<Message & FetchDataType>();

const initialState: MessagesState = {
  hasMore: true,
  hasNew: false,
  chatOptions: initialChatOptions,
};

const messagesSlice = createSlice({
  initialState: messageAdapter.getInitialState<MessagesState>(initialState),
  name: Reducers.MESSAGES,
  reducers: {
    ...extractSharedActions(messageAdapter),
    resetChatOptions: (state) => {
      state.chatOptions = initialChatOptions;
    },
    setChatOptions: (state, action: PayloadAction<Partial<ChatOptions>>) => {
      state.chatOptions = {
        ...state.chatOptions,
        ...action.payload || {},
      };
    },
    setHasMore: (state, action: PayloadAction<boolean>) => {
      state.hasMore = action.payload;
    },
  },
});

export const {
  removeOne: removeMessage, resetChatOptions, setChatOptions,
  setHasMore, upsertOne: upsertMessage, upsertMany: upsertMessages, addOne: addMessage,
} = messagesSlice.actions;

export default messagesSlice.reducer;
